import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { ScrollComponent } from '../../../../common/scrollComponent'
import LayoutContainer from './LayoutContainer'
import LayoutItem from './LayoutItem'
import classes from './index.module.scss'
import { selectPanelId } from './store/slice'

const SettingLayout = () => {
  const panelId = useSelector(selectPanelId)

  return (
    <div className="dFlex flexColumn h100">
      <Element className="fw600" style={{ fontSize: 14, color: '#191D25' }}>
        <Translate value="preferenceSetting.WORKSPACE_PREVIEW" />
      </Element>
      <div className={classes.mt4}>
        <Translate value="preferenceSetting.WORKSPACE_PREVIEW_NOTE" />
      </div>
      <div className={`h100 pt3 ${classes.layoutContainer}`}>
        <ScrollComponent>
          <div className={classes.scrollContent}>
            <LayoutContainer>
              {panelId.map((id) => (
                <LayoutItem key={id} id={id} />
              ))}
            </LayoutContainer>
          </div>
        </ScrollComponent>
      </div>
    </div>
  )
}

export default SettingLayout
